"use client";

import { LifeBuoy, Headset } from "lucide-react";
import LogoIcon from "@/icons/LogoIcon";

export function Header() {

  return (
    <div className="wy-header cy:border-b cy:border-gray-200">
      <div className="cy:max-w-7xl cy:w-full cy:mx-auto">
        <div className="cy:flex cy:justify-between cy:items-center cy:py-4 cy:px-2">
          <div className="cy:flex cy:items-center cy:space-x-3">
            <div className="wy-flex">
              <LogoIcon className="cy:w-[201px] cy:h-[38px] cy:text-white" />
            </div>
          </div>
          <div className="cy:flex cy:items-center cy:gap-3">
            <div className="cy:flex cy:items-center cy:space-x-12">
              <a
                href="https://www.webyes.com/documentation/wordpress-accessibility-toolkit-plugin-setup/"
                target="_blank"
                className="cy:inline-flex cy:items-center cy:justify-center cy:whitespace-nowrap cy:text-sm cy:transition-all cy:disabled:pointer-events-none cy:disabled:opacity-50 cy:[&_svg]:pointer-events-none  cy:shrink-0 cy:[&_svg]:shrink-0 cy:outline-none cy:focus-visible:border-ring cy:focus-visible:ring-ring/50 cy:focus-visible:ring-[3px] cy:aria-invalid:ring-destructive/20 cy:dark:aria-invalid:ring-destructive/40 cy:aria-invalid:border-destructive cy:bg-transparent cy:h-8 cy:rounded-md cy:gap-1.5 cy:px-3 cy:border-1 cy:border-white cy:text-white! cy:hover:bg-white cy:hover:text-black!"
              >
                <LifeBuoy className="cy:h-4 cy:w-4" />  Help Guides
              </a>
            </div>
            <div className="cy:flex cy:items-center cy:space-x-12">
              <a
                href="https://wordpress.org/support/plugin/accessibility-plus/"
                target="_blank"
                className="cy:inline-flex cy:items-center cy:justify-center cy:whitespace-nowrap cy:text-sm cy:transition-all cy:disabled:pointer-events-none cy:disabled:opacity-50 cy:[&_svg]:pointer-events-none  cy:shrink-0 cy:[&_svg]:shrink-0 cy:outline-none cy:focus-visible:border-ring cy:focus-visible:ring-ring/50 cy:focus-visible:ring-[3px] cy:aria-invalid:ring-destructive/20 cy:dark:aria-invalid:ring-destructive/40 cy:aria-invalid:border-destructive cy:bg-transparent cy:h-8 cy:rounded-md cy:gap-1.5 cy:px-3 cy:border-1 cy:border-white cy:text-white! cy:hover:bg-white cy:hover:text-black!"
              >
                <Headset className="cy:h-4 cy:w-4" /> Support
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
